import Link from 'next/link';
import React from 'react';

export const SidebarFooter = () => {
  return (
    <div className='flex flex-col absolute w-full pr-12 justify-between text-xs bottom-0 '>
      <p className='text-xs font-light uppercase py-2 text-grey-600'>Socials</p>
      <div className='flex justify-between border-t-[0.05px] text-grey-500 border-grey-800 w-full py-3'>
        <Link href='https://www.linkedin.com/company/teelor/' className='hover:text-dark-400'>LinkedIn</Link>
      </div>
    </div>
  );
};
